import _suggestCloseCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg";
import _suggestWarningFill from "@zenlayer/zen-design-icons/assets/suggest/WarningFill.svg";
import _suggestInfoCircleFill from "@zenlayer/zen-design-icons/assets/suggest/InfoCircleFill.svg";
import _suggestCheckCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CheckCircleFill.svg";
import { notification } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { getConfig } from '../hooks/useConfig';
import Icon from '../icon';
import { jsx as _jsx } from "react/jsx-runtime";
const prefixClass = 'zen-design'; // TODO
const baseClassName = "".concat(prefixClass, "-notification");
const open = config => {
  const {
    message,
    className,
    ...otherConfig
  } = config || {};
  const defaultConfig = {
    ...otherConfig,
    message,
    className: classNames(baseClassName, "".concat(baseClassName, "-open"), className)
  };
  notification.open(defaultConfig);
};
const success = config => {
  const {
    message,
    className,
    ...otherConfig
  } = config || {};
  const {
    locale: {
      Notification: NotificationLocale
    }
  } = getConfig();
  const defaultConfig = {
    ...otherConfig,
    message: message || NotificationLocale.message_success,
    icon: /*#__PURE__*/_jsx(Icon, {
      type: "suggest/CheckCircleFill",
      block: true
    }),
    className: classNames(baseClassName, "".concat(baseClassName, "-success"), className)
  };
  notification.success(defaultConfig);
};
const info = config => {
  const {
    message,
    className,
    ...otherConfig
  } = config || {};
  const {
    locale: {
      Notification: NotificationLocale
    }
  } = getConfig();
  const defaultConfig = {
    ...otherConfig,
    message: message || NotificationLocale.message_info,
    icon: /*#__PURE__*/_jsx(Icon, {
      type: "suggest/InfoCircleFill",
      block: true
    }),
    className: classNames(baseClassName, "".concat(baseClassName, "-info"), className)
  };
  notification.info(defaultConfig);
};
const warning = config => {
  const {
    message,
    className,
    ...otherConfig
  } = config || {};
  const {
    locale: {
      Notification: NotificationLocale
    }
  } = getConfig();
  const defaultConfig = {
    ...otherConfig,
    message: message || NotificationLocale.message_warning,
    icon: /*#__PURE__*/_jsx(Icon, {
      type: "suggest/WarningFill",
      block: true
    }),
    className: classNames(baseClassName, "".concat(baseClassName, "-warning"), className)
  };
  notification.warning(defaultConfig);
};
const error = config => {
  const {
    message,
    className,
    ...otherConfig
  } = config || {};
  const {
    locale: {
      Notification: NotificationLocale
    }
  } = getConfig();
  const defaultConfig = {
    ...otherConfig,
    message: message || NotificationLocale.message_error,
    icon: /*#__PURE__*/_jsx(Icon, {
      type: "suggest/CloseCircleFill",
      block: true
    }),
    className: classNames(baseClassName, "".concat(baseClassName, "-error"), className)
  };
  console.log(message || otherConfig.description || 'error occurred');
  notification.warning(defaultConfig);
};
export default {
  open,
  success,
  info,
  warning,
  error,
  close: notification.destroy,
  config: notification.config
};